import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import SourcingIcon from 'dibs-vg/dist/react/chair-search';
import { SbSharedPriceTile } from '../../SbSharedPriceTile/SbSharedPriceTile';

import styles from './SbRespTradeOnApprovalPromoTile.scss';

export const SbRespTradeOnApprovalPromoTileComponent = props => {
    const { position, searchBrowse, viewer } = props;
    const displayUriRef = get(searchBrowse, 'displayUriRef');
    const isTradeOnApprovalEnabled = get(viewer, 'onApprovalEnabled');

    let tileProps = {
        dataTn: 'priceTile-sourcing',
        displayName: (
            <FormattedMessage
                id="sb.SbRespTradeOnApprovalPromoTile.getSourcingHelp"
                defaultMessage="Get Sourcing Help"
            />
        ),
        hoverMessage: (
            <FormattedMessage
                id="sb.SbRespTradeOnApprovalPromoTile.submitSourcingRequest"
                defaultMessage="submit a sourcing request"
            />
        ),
        image: 'https://a.1stdibscdn.com/assets/trade/sb_price_tile_sourcing.jpg?height=180',
        promoLabel: 'Sourcing Help',
        isSbUrl: false,
        url: '/trade/sourcing/',
    };

    if (isTradeOnApprovalEnabled) {
        tileProps = {
            dataTn: 'priceTile-on-approval',
            displayName: (
                <FormattedMessage
                    id="sb.SbRespTradeOnApprovalPromoTile.onApprovalTitle"
                    defaultMessage="On Approval"
                />
            ),
            hoverMessage: (
                <React.Fragment>
                    <FormattedMessage
                        id="sb.SbRespTradeOnApprovalPromoTile.shopEligibleItems"
                        defaultMessage="shop eligible items"
                    />
                    <div className={styles.hoverMessageLine2}>
                        <FormattedMessage
                            id="sb.SbRespTradeOnApprovalPromoTile.domesticRequestsOnly"
                            defaultMessage="Domestic US Requests Only"
                        />
                    </div>
                </React.Fragment>
            ),
            image:
                'https://a.1stdibscdn.com/assets/trade/on-approval/on-approval-tile.jpg?height=180',
            promoLabel: 'On Approval',
            url: `/locations/usa-north-america${displayUriRef}`,
        };
    }

    return (
        <SbSharedPriceTile
            {...tileProps}
            IconComponent={SourcingIcon}
            position={position}
            searchBrowse={searchBrowse}
        />
    );
};

SbRespTradeOnApprovalPromoTileComponent.propTypes = {
    position: PropTypes.number,
    searchBrowse: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const SbRespTradeOnApprovalPromoTile = createFragmentContainer(
    SbRespTradeOnApprovalPromoTileComponent,
    {
        searchBrowse: graphql`
            fragment SbRespTradeOnApprovalPromoTile_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedPriceTile_searchBrowse
                displayUriRef
            }
        `,
        viewer: graphql`
            fragment SbRespTradeOnApprovalPromoTile_viewer on Viewer {
                onApprovalEnabled: isEnabled(key: "onApprovalEnabled")
            }
        `,
    }
);
